// src/components/OptionFields/CompareFieldRenderer.tsx
// 比較・統合モード用のフィールドレンダラー

import React from 'react';
import { Input, Typography, Space, Radio } from 'antd';

const { Text } = Typography;

interface CompareFieldRendererProps {
  currentValue?: any;
  duplicateValue?: any;
  onCurrentChange: (value: any) => void;
  onDupeSelectChange: (mode: 'union' | 'dupe') => void;
  dupeSelectMode: 'union' | 'dupe';
  fieldName: string;
  placeholder: string;
  className?: string;
  isReadOnly?: boolean;
}

/**
 * 比較・統合モード用のフィールドレンダラー
 * 重複データの比較と統合機能を提供
 */
export const CompareFieldRenderer: React.FC<CompareFieldRendererProps> = ({
  currentValue,
  duplicateValue,
  onCurrentChange,
  onDupeSelectChange,
  dupeSelectMode,
  fieldName,
  placeholder,
  className,
  isReadOnly = false
}) => {
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {/* 現在値の入力 */}
      <div>
        <Text strong>現在値:</Text>
        <Input
          value={currentValue || ''}
          onChange={(e) => onCurrentChange(e.target.value)}
          placeholder={placeholder}
          className={className}
          disabled={isReadOnly}
        />
      </div>

      {/* 重複値の表示 */}
      <div>
        <Text strong>重複値:</Text>
        <div 
          style={{
            padding: '4px 11px',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            backgroundColor: '#f5f5f5',
            minHeight: '32px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Text>{duplicateValue || '--'}</Text>
        </div>
      </div>

      {/* 統合モード選択 */}
      {duplicateValue && (
        <div>
          <Text strong>統合方法:</Text>
          <Radio.Group
            value={dupeSelectMode}
            onChange={(e) => onDupeSelectChange(e.target.value)}
            size="small"
          >
            <Radio value="union">統合 (現在値 + 重複値)</Radio>
            <Radio value="dupe">重複値を採用</Radio>
          </Radio.Group>
        </div>
      )}
    </Space>
  );
};

export default CompareFieldRenderer;